import React, { createContext } from 'react';

const baseContext = createContext({});
const fraudContext = createContext({});
const SurveyContext = createContext({});

export { baseContext, fraudContext, SurveyContext };
